import { render, staticRenderFns } from "./pro-baseinfo.vue?vue&type=template&id=4ee9ece8&scoped=true"
import script from "./pro-baseinfo.vue?vue&type=script&lang=js"
export * from "./pro-baseinfo.vue?vue&type=script&lang=js"
import style0 from "./pro-baseinfo.vue?vue&type=style&index=0&id=4ee9ece8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee9ece8",
  null
  
)

export default component.exports